import type { Contents } from '@/wabunka-src/common/features/Featured/models/featured/featured';

interface ContentOwner {
  contents: Contents;
  contentsBottom?: Contents;
}

/**
 * microCMSから返ってくるページの記事情報の中にある体験セクション情報のウェブセクションIDを抽出する
 * contents と contentsBottom の両方を対象とする
 */
export const useExtractWebSectionIds = (featuredFromCMS: Ref<ContentOwner>) => {
  const allContents = [...(featuredFromCMS.value.contents ?? []), ...(featuredFromCMS.value.contentsBottom ?? [])];

  const webSectionIds = [
    ...new Set(
      allContents
        .filter((section) => section?.fieldId === 'experienceSectionIDs')
        .flatMap((section) => (section as { experienceSectionIDs: { experienceSectionId: string }[] }).experienceSectionIDs.map((item) => item.experienceSectionId)),
    ),
  ];

  return { webSectionIds: ref(webSectionIds) };
};
